import { Sample, DownloadableItemSource } from 'types';

export const isSample = (item: DownloadableItemSource): item is Sample => {
    return (item as Sample).credits !== undefined;
};
